/**
 * Sends a custom conversion event to the Webflow Optimize/Analyze API.
 *
 * @param {string} eventName - Name of the custom goal event (must match the goal name in Webflow).
 */
const sendIntellimizeEvent = (eventName) => {
  if (window.parent.wf && typeof window.parent.wf.sendEvent === "function") {
    window.parent.wf.sendEvent(eventName);
  }
};

export default {
  sendIntellimizeEvent,
};